<template>
    <div class="expert-panel-review">
        <main>
            <Breadcrumbs :items="breadcrumbs"/>
            <div class="expert-panel-review__wrap" v-if="review" v-loading="!review || !reviewSession">
                <ExpertPanelReviewHeader
                    :review="review"
                    :session="reviewSession"
                    :readonly="reviewSession.status === 'completed'"
                />
                <div class="expert-panel-review__body">
                    <div>
                        <ExpertPanelReviewParticipant
                            :review="review"
                            :session="reviewSession"
                        />
                    </div>
                    <div>
                        <ExpertPanelReviewAssessmentSuper
                            v-if="reviewSession.reviewExpert && reviewSession.reviewExpert.isSuper"
                            :review="review"
                            :session="reviewSession"
                            :readonly="reviewSession.status === 'completed'"
                        />
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import Breadcrumbs from "@/components/UI/Breadcrumbs.vue";
import ExpertPanelReviewHeader from "@/components/expert-panel-new/review/ExpertPanelReviewHeader.vue";
import ExpertPanelReviewParticipant from "@/components/expert-panel-new/review/ExpertPanelReviewParticipant.vue";
import ExpertPanelReviewAssessmentSuper
    from "@/components/expert-panel-new/review/super/ExpertPanelReviewAssessmentSuper.vue";
import {mapGetters} from "vuex";

export default {
    name: "ExpertPanelReview",
    components: {
        ExpertPanelReviewAssessmentSuper,
        ExpertPanelReviewParticipant,
        ExpertPanelReviewHeader,
        Breadcrumbs,
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters('examination', ['currentReviewSession']),
        breadcrumbs() {
            return [
                { text: 'Кабинет эксперта', path: { name: 'expert-panel' } },
                { text: this.name, path: {name: 'expert-panel-event', type: 'review', event: this.eventId} },
                { text: this.sessionId },
            ];
        },
        type() {
            return this.$route.params['type'];
        },
        eventId() {
            return +this.$route.params['event'];
        },
        event() {
            const type = this.$store.state.examination.events[this.type];

            return type ? type.items.find(t => t.id === this.eventId) : null;
        },
        name() {
            return this.event ? this.event.name : '';
        },
        sessionId() {
            return +this.$route.params['session'];
        },
        review() {
            const ret = this.$store.getters['examination/review'](this.eventId);
            if (ret && this.reviewSession) {
                ret.sessionId = this.reviewSession.activitySession.id;
                return ret;
            }
            return null;
        },
        reviewSession() {
            return this.currentReviewSession;
        },
    },
    methods: {

    },
    created() {
        this.$store.dispatch('examination/unloadReviewSessions');
        this.$store.dispatch('examination/loadEvents');

        const workSessionConfig = {
            type: this.type,
            eid: this.eventId,
            sid: this.sessionId,
            isSuper: true,
        };

        this.$store
            .dispatch('examination/loadWorkSession', workSessionConfig)
            .then(() => {
                this.$store.dispatch('examination/loadReview', this.eventId);
                this.$store.dispatch('examination/loadReviewSession', {
                    reviewId: this.eventId,
                    activitySessionId: this.sessionId,
                    isSuper: 1,
                });
            });
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.expert-panel-review {
  main {
    padding: rem(44) rem(156);

    :deep(.breadcrumbs) {
      height: auto;
    }
  }
  &__wrap {
    display: flex;
    flex-direction: column;
    gap: rem(40);
    margin-top: rem(32);
  }
  &__body {
    display: flex;
    flex-direction: row;
    gap: rem(40);
    & > div {
      flex: 1;
      width: 50%;
    }
  }
}
</style>